<div class="debug" *ngIf="componentType" @AnimateSlides1>
    <gp-component-container  [ComponentType]="componentType">
        Loading...
    </gp-component-container> 
</div>